type Props = {
  color?: string;
};

export const Share = ({ color = 'black' }: Props) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19 0C19.1357 0 19.2652 0.0270469 19.3832 0.0760455L19.9933 0.884315L20 1V7C20 7.55228 19.5523 8 19 8C18.4872 8 18.0645 7.61396 18.0067 7.11662L18 7L17.9998 3.41443L9.70711 11.7071C9.31658 12.0976 8.68342 12.0976 8.29289 11.7071C7.93241 11.3466 7.90468 10.7794 8.2097 10.3871L8.29289 10.2929L16.5858 2H13C12.4872 2 12.0645 1.61396 12.0067 1.11662L12 1C12 0.487164 12.386 0.0644928 12.8834 0.00672773L13 0H19Z"
        fill={color}
      />
      <path
        d="M5 3C5 2.44772 4.55228 2 4 2H3L2.82378 2.00509C1.24945 2.09638 0 3.40287 0 5V17L0.0050948 17.1762C0.0963783 18.7506 1.40287 20 3 20H15L15.1762 19.9949C16.7506 19.9036 18 18.5971 18 17V16L17.9933 15.8834C17.9355 15.386 17.5128 15 17 15C16.4477 15 16 15.4477 16 16V17L15.9933 17.1165C15.9354 17.6135 15.5123 18 15 18H3L2.88348 17.9933C2.38653 17.9354 2 17.5123 2 17V5L2.00674 4.88348C2.06457 4.38653 2.48769 4 3 4H4L4.11662 3.99327C4.61396 3.93551 5 3.51284 5 3Z"
        fill={color}
      />
    </svg>
  );
};
